<template>
    <NotificationBanner v-if="isVisible" :storageKey="maintenanceDateTimestampString">
      {{ formattedMessage }}
      If you have any questions, please contact us at <a :href="supportEmail">support@traackr.com</a>
    </NotificationBanner>
  </template>

  <script>
  import NotificationBanner from '@/components/NotificationBanner.vue';
  import dates from '@/utils/dates.js';

  export default {
    components: {
      NotificationBanner
    },
    data() {
      return {
        isVisible: true,
        currentDate: new Date().getTime(),
        maintenanceDate: {},
        maintenanceBannerEnable: window.SAILS_LOCALS?.maintenanceBannerEnable === 'true',
        maintenanceDuration: window.SAILS_LOCALS?.maintenanceDuration || '',
      };
    },
    computed: {
      formattedMessage() {
        const message = window.SAILS_LOCALS?.maintenanceMessage || '';

        if (message && this.isVisible) {
          return message
            .replace('[MAINTENANCE_DATE]', this.maintenanceDate?.dateString)
            .replace('[MAINTENANCE_DURATION]', this.maintenanceDuration);
        }
        return '';
      },
      maintenanceDateTimestampString() {
       return this.maintenanceDate?.date ? `${this.maintenanceDate.date}` : '';
     },
     supportEmail() {
            return `mailto:${window.SAILS_LOCALS?.supportEmail || 'support@traackr.com'}`;
        }
    },
    created() {
      const message = window.SAILS_LOCALS?.maintenanceMessage || '';
      this.maintenanceDate = dates.convertUTCToLocal(window.SAILS_LOCALS?.maintenanceDate);

      if (message && this.maintenanceBannerEnable && this.maintenanceDate && this.maintenanceDate.date > this.currentDate) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    }
  };
  </script>

  <style scoped>
  .notification {
    margin-bottom: 1rem;
  }
  </style>
